import React from 'react';
import Box from '@mui/material/Box';
import { Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../hook/Translation';

export default function TextBtnSection({ data, titleSize, descriptionSize }) {
    const { t } = useTranslation();
    return (
        <Box>
            <Grid container gap={'41px'}>
                <Grid size={12}>
                    <Grid container spacing={0} justifyContent={'center'}>
                        <Grid size={12}>
                            <Grid container gap={'20px'} justifyContent={'center'}>
                                <Grid size={12}>
                                    <Typography variant="body1" color="text.secondary" textAlign={'center'} fontWeight={'600'} fontSize={'1.125rem'}>{data?.type}</Typography>
                                </Grid>
                                <Grid size={titleSize ?? 12}>
                                    <Typography variant="body1" color="text.secondary" textAlign="center" fontSize={{ md: '2.875rem', xs: '1.7rem' }} sx={{ whiteSpace: 'pre-wrap' }} fontWeight="bold" fontFamily="DanmarkURW" dangerouslySetInnerHTML={{ __html: data?.title }} />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={descriptionSize ?? { md: 8, xs: 12 }}>
                            <Typography variant="body1" color="text.secondary" textAlign={'center'} fontSize={'1rem'} sx={{ whiteSpace: 'pre-wrap' }}>{data?.description}</Typography>
                        </Grid>
                        {
                            data?.price &&
                            <Grid size={{ md: 8, xs: 12 }} mt={'20px'}>
                                <Typography variant="body1" fontWeight={'600'} color="text.secondary" textAlign={'center'} fontSize={'18px'} sx={{ whiteSpace: 'pre-wrap' }}>{data?.price}</Typography>
                            </Grid>
                        }
                        
                    </Grid>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }} marginX={'auto'}>
                    <Grid container spacing={4} justifyContent={'center'} marginX={'auto'}>
                        {
                            data?.bookUrl &&
                            <Grid size={6}>
                                <Button LinkComponent={Link} to={data?.bookUrl} target={data.target ?? ''} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor defaultButton noShadow buttonTextSize' sx={{ color: 'primary.main', backgroundColor: 'secondary.main' }}>
                                    {t('book_now')}
                                </Button>
                            </Grid>
                        }

                        {
                            data?.learnUrl &&
                            <Grid size={6}>
                                <Button LinkComponent={Link} to={data?.learnUrl} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor defaultButton noShadow buttonTextSize' color='text.secondary'>
                                    {t('learn_more')}
                                </Button>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                {
                    data?.doctorIncluded &&
                    <Grid size={{ md: 12, xs: 12 }}>
                        <Typography variant="body1" fontWeight={'600'} color="text.secondary" textAlign={'center'} fontSize={'12px'} sx={{ whiteSpace: 'pre-wrap' }}>{t('doctorIncluded')}</Typography>
                    </Grid>
                }
            </Grid>
        </Box>
    )
}